import React, { Suspense, useReducer } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import theme from './theme';
import routes from './routes';
import { ScrollReset, GoogleAnalytics, CookiesNotification } from './components';
import './assets/scss/index.scss';

import { Provider as ProviderAuth } from './contexts/AuthContext';
import { Provider as ProviderCountries } from './contexts/CountriesContext';

import { authReducer, initialAuthState } from './reducers/authReducer';
import { countriesReducer, initialCountriesState } from './reducers/countriesReducer';
import { LinearProgress } from '@material-ui/core';

const AppContent = () => {
  const routing = useRoutes(routes);
  return (
    <Suspense fallback={<LinearProgress />}>
      {routing}
    </Suspense>
  );
};

const App = () => {
  const authState = useReducer(authReducer, initialAuthState);
  const countriesState = useReducer(countriesReducer, initialCountriesState);

  return (
    <ProviderCountries value={countriesState}>
      <ProviderAuth value={authState}>
        <ThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <BrowserRouter>
              <ScrollReset />
              <GoogleAnalytics />
              <CookiesNotification />
              <AppContent />
            </BrowserRouter>
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </ProviderAuth>
    </ProviderCountries>
  );
};

export default App;
